<template>
  <!-- eslint-disable max-len -->
  <div>
    <div class="container">
      <div class="content">
        <ul ref="vertList" class="vert-list c-availability-list">
          <li v-for="(weeks, monthStart) in availabilityList" :key="monthStart" class="vert-list__item">
            <div class="heading-bar">
              <h1 class="hdg hdg--4">
                {{ monthHeader(monthStart) }}
              </h1>
            </div>

            <div v-for="(days, weekStart) in weeks" :key="weekStart">
              <div v-if="showWeekHeader(monthStart, weekStart)" class="heading-bar-underline">
                <h2 class="section-heading">{{ weekHeader(weekStart) }}</h2>
              </div>
              <ul v-if="firstWeek(monthStart, weekStart)" class="vert-list">
                <li class="vert-list__item">
                  <div class="listing">
                    <div class="listing__identifier listing__identifier--empty">
                      <div class="listing__top">{{ dayHeader }}</div>
                      <div class="listing__bottom">{{ dateHeader }}</div>
                    </div>
                    <div class="listing__group" @click.prevent="triggerClick">
                      <div class="listing__empty-availability">
                        <p class="listing__empty-availability-heading">No availability added</p>
                        <p>Use + below to add</p>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <!-- eslint-enable max-len -->
</template>

<script lang="ts">
import { addDays } from 'date-fns/addDays';
import { format } from 'date-fns';
import { generateMonths, showWeekHeader, monthHeader, weekHeader } from '../../lib/availability';

export default {
  name: 'EmptyAvailability',
  computed: {
    availabilityList(): any {
      const earliest = new Date();
      const latest = addDays(earliest, 30);
      return generateMonths(earliest, latest);
    },
    dayHeader(): string {
      return format(new Date(), 'eee');
    },
    dateHeader(): string {
      return format(new Date(), 'd');
    },
  },
  methods: {
    showWeekHeader,
    monthHeader,
    weekHeader,
    firstWeek(month: string, week: string): boolean {
      const firstMonth = Object.keys(this.availabilityList).sort()[0];
      if (month !== firstMonth) return false;
      const firstWeek = Object.keys(this.availabilityList[firstMonth]).sort()[0];
      return week === firstWeek;
    },
    triggerClick() {
      this.$emit('click');
    },
  },
};
</script>
